@if (vm$ | async; as vm) {
  <div class="uw-dialog-header">
    <h1 class="uw-dialog-heading">{{ "common.select" | translate }} UnitedWay</h1>
  </div>
  <div class="uw-dialog-content">
    <div class="unitedway-list__container">
      @for (uw of vm.unitedWayList; track uw) {
        <div class="list-item">
          <div class="title"> {{uw.name}} </div>
          <div class="option"><button class="uw-stroked-button uw-button--xsmall" (click)="onSelect(uw)"> {{ "common.select" | translate }} </button> </div>
        </div>
      }
    </div>
  </div>
}
